import { render, staticRenderFns } from "./StaticWallpaperUploader.vue?vue&type=template&id=044bc506&scoped=true&"
import script from "./StaticWallpaperUploader.vue?vue&type=script&lang=js&"
export * from "./StaticWallpaperUploader.vue?vue&type=script&lang=js&"
import style0 from "./StaticWallpaperUploader.vue?vue&type=style&index=0&id=044bc506&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044bc506",
  null
  
)

export default component.exports